import { trackEvent2 } from '@shared/statistics';

export function trackShowMustReadMessage(messageId: string): void {
    trackEvent2('bankMessages', 'mandatoryMessageDisplayed', { messageId });
}

export function trackDownloadAttachment(messageId: string, attachmentId: string): void {
    trackEvent2('bankMessages', 'mandatoryMessageAttachmentSelected', { messageId, attachmentId });
}

export function trackLogout(messageId: string): void {
    trackEvent2('bankMessages', 'mandatoryMessageCancelled', { messageId });
}

export function trackAcknowledgeMessage(messageId: string): void {
    trackEvent2('bankMessages', 'mandatoryMessageRead', { messageId });
}
